export const FRONTEND_PUBLIC_URL = 'https://k24-frontend-public.hb.kz-ast.bizmrg.com';

export const OFFER_LINK_RUS = `${FRONTEND_PUBLIC_URL}/public-documents/Договор_комплексного_обслуживания_RUS.pdf`;

export const OFFER_LINK_KAZ = `${FRONTEND_PUBLIC_URL}/public-documents/Договор_комплексного_обслуживания_KAZ.pdf`;

export const OFFER_DOCUMENT_VERSION = '2025-11';
